import { PaymentProvider } from "../../../generated/graphql"
import { PaymentMethodType } from "../../../helpers/getPaymentMethodType"

/** Mollie-Method-String für Banktransfer — identisch zum Picker-Wert (MollieMethodsBlock). */
export const MOLLIE_BANKTRANSFER_METHOD = "banktransfer"

/**
 * WS-1f — Entscheidet, ob eine im STANDARD-Buchungs-Flow gewählte „Überweisung"
 * über Mollie abgewickelt werden soll.
 *
 * Hintergrund: Setzt der Tenant `bankTransferProvider=Mollie`, erzeugt der Server
 * aus einer Überweisungs-Buchung server-seitig eine Mollie-banktransfer-Zahlung.
 * In diesem Fall soll der Checkout NICHT mehr deferred sein, sondern wie der
 * Mollie-Picker-banktransfer laufen: sofort `initiate` → Return-Page mit
 * On-Screen-IBAN (statt generischer Erfolgsseite ohne Bankdaten).
 *
 * Liefert `false`, wenn
 *  - bereits eine Mollie-Picker-Methode gewählt wurde (die läuft schon korrekt
 *    über `selectedMollieMethod`),
 *  - der Tenant Überweisungen NICHT über Mollie abwickelt
 *    (`bankTransferProvider !== Mollie`, inkl. `null`/`undefined` solange das
 *    Feld server-seitig noch nicht exponiert ist),
 *  - oder die gewählte Standard-Methode keine Überweisung ist (Bar/Lastschrift/…
 *    bleiben unverändert).
 */
export function isStandardBankTransferViaMollie(params: {
    bankTransferProvider: PaymentProvider | null | undefined
    selectedStandardMethodType: PaymentMethodType | null | undefined
    selectedMollieMethod: string | null
}): boolean {
    const { bankTransferProvider, selectedStandardMethodType, selectedMollieMethod } = params

    // Mollie-Picker-Auswahl läuft bereits über den bestehenden Pfad.
    if (selectedMollieMethod) {
        return false
    }
    // Nur wenn der Tenant Überweisungen explizit über Mollie abwickelt.
    if (bankTransferProvider !== PaymentProvider.Mollie) {
        return false
    }
    return selectedStandardMethodType === "bankTransfer"
}
